




































































import {Component, Vue} from "vue-property-decorator";
import {namespace, Action} from "vuex-class";

import {DroppoErrors} from '@/constants/errors';
import ShipmentForm from '@/views/components/ShipmentForm.vue';
import {IActiveShipment, IHub} from '@/models/StoreModels';
import {IPhoneNumber} from '@/models/IPhoneNumber';
import {cellSizesTranslatedStrings, ORDER_PROCESS_DROPUP_PAGE} from '@/constants/orders';
import {errorHandler} from "@/services/services";
import {IApiErrors} from "@/models/ApiModels";
import {isErrorType} from "@/services/errorHandling";
import {CROSS_TOWN_ROUTES} from "@/constants/routes";

const shipmentStore = namespace("shipment");
const hubsStore = namespace("hubs");

@Component({
  name: 'Summary',
  components: {
    ShipmentForm,
  },
})
export default class Summary extends Vue {

  @shipmentStore.Getter("getFormattedToPhoneNumber")
  private getFormattedToPhoneNumber!: IPhoneNumber;

  @shipmentStore.Getter("crosstownDataIsCorrect")
  private crosstownDataIsCorrect!: boolean;

  @shipmentStore.Getter("getFromHubId")
  private sGetFromHubId!: number;

  @shipmentStore.Getter("getCellSize")
  private sGetCellSize!: number;

  @shipmentStore.Getter("getNote")
  private sGetNote!: string;

  @hubsStore.Getter('getHubById')
  private getHubById!: (id: number) => IHub;

  @hubsStore.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  @Action('createCrosstownShipment')
  private createCrosstownShipment!: () => Promise<IActiveShipment>;

  get selectedHub(): IHub {
    return this.getHubById(this.sGetFromHubId);
  }

  get cellSize() {
    return cellSizesTranslatedStrings(this.sGetCellSize);
  }


  get address() {
    return this.getHubById(this.sGetFromHubId).address;
  }


  private errors: IApiErrors = {};

  private next() {
    this.clearErrors();
    if (this.crosstownDataIsCorrect) {
      this.$uiBus.emit("apiStatus:loading");
      this.createCrosstownShipment()
        .then((activeShipment: IActiveShipment) => {
          this.$uiBus.emit("apiStatus:finish", activeShipment.id);
          this.$router.push({ name: CROSS_TOWN_ROUTES.FINISH, params: { asId: `${ activeShipment.id }` }});
        })
        .catch(this.showErrors);
    }
  }

  private showErrors(err: any) {
    if (isErrorType(DroppoErrors.NO_CELL_ERROR, err)) {
      this.$uiBus.emit('crossTown:goToSelectCellSize');
    }
    this.$uiBus.emit("apiStatus:error");
    const errors = errorHandler.handleErrorsResponse(err, 'deliverySummary.errors');
    Vue.set(this, 'errors', errors);
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private goToPhone() {
    this.clearErrors();
    this.$router.push({
      name: CROSS_TOWN_ROUTES.FORM,
      params: {
        dropup: ORDER_PROCESS_DROPUP_PAGE.RECEIVER_PHONE,
      },
    });
  }

  private GoToSelectCellSize() {
    this.clearErrors();
    this.$router.push({
      name: CROSS_TOWN_ROUTES.FORM,
      params: {
        dropup: ORDER_PROCESS_DROPUP_PAGE.CELL_CHOOSER,
      },
    });
  }

  private goToSelectAddress() {
    if (!this.existsOnlyOneHub) {
      this.clearErrors();
      this.$router.push({
        name: CROSS_TOWN_ROUTES.FORM,
        params: {
          dropup: ORDER_PROCESS_DROPUP_PAGE.SELECT_HUB,
        },
      });
    }
  }

  private goToNote() {
    this.clearErrors();
    this.$router.push({name: CROSS_TOWN_ROUTES.FORM});
  }
}
